import { configureStore } from '@reduxjs/toolkit';
import authSliceReducer from './reducer/authSlice';
import categorieSliceReducer from './reducer/categorySlice';
import productSliceReducer from './reducer/productSlice';
import orderSliceReducer from './reducer/ordersSlice';
import addressSliceReducer from './reducer/addressSlice';
import cartSliceReducer from './reducer/cartSlice';
import menuSliceReducer from './reducer/menuSlice';
import checkoutSliceReducer from './reducer/checkoutSlice';
import adminSliceReducer from './reducer/adminSlice';
import deliveryPartnerSliceReducer from './reducer/deliveryPartnerSlice';
import qurbaniSliceReducer from './reducer/qurbaniSlice';
export const store = configureStore({
    reducer: {
        auth: authSliceReducer,
        categories: categorieSliceReducer,
        products: productSliceReducer,
        orders: orderSliceReducer,
        address: addressSliceReducer,
        cart: cartSliceReducer,
        menus: menuSliceReducer,
        checkout: checkoutSliceReducer,
        admin: adminSliceReducer,
        deliveryPartner: deliveryPartnerSliceReducer,
        qurbani: qurbaniSliceReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: true,
});
